import { FeatureState } from 'omni-package-react-core';
import { PersonalInformation } from './interfaces/PersonalInformation';
export default class State implements FeatureState {
  readonly featurePath = '/App.features.personalInformation';
  personalInformationResource: {
    pending: boolean;
    error: {
      message: string;
      status: number;
    };
  };
  info: PersonalInformation;
}
